import gql from 'graphql-tag'

export const DXP_ITEMS_DISMISS_MUTATION = gql`
    mutation dxpItemsDismiss(
        $dxpItemIds: [ID!]!
    ) {
        dxpItemsDismiss(
            dxp_item_ids: $dxpItemIds
        ) {
            ... on DxpInboxItem {
                id
                created_at
                updated_at
            }
            ... on DxpOutboxItem {
                id
                created_at
                updated_at
            }
        }
    }
`
